import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  FaHome,
  FaImages,
  FaPray,
  FaClock,
  FaCalendarAlt,
  FaInfoCircle,
  FaVideo,
  FaLink,
  FaPhoneAlt,
  FaOm,
  FaBars,
  FaTimes,
  FaUsers,
  FaDonate,
  FaUserCircle,
  FaSignOutAlt,
  FaSignInAlt,
  FaTachometerAlt,
  FaStar,
} from "react-icons/fa";

import "../styles/Sidebar.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  /* ================= AUTH STATE ================= */
  const isLoggedIn = !!localStorage.getItem("adminToken");

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("admin");
    navigate("/admin/login");
  };

  /* ================= MENU ITEMS ================= */

  const menuItems = [
    { title: "Dashboard", icon: <FaTachometerAlt />, path: "/admin/dashboard" },
    { title: "Home Content", icon: <FaHome />, path: "/admin/home" },
    { title: "About", icon: <FaInfoCircle />, path: "/admin/about" },
    { title: "Poojas", icon: <FaPray />, path: "/admin/poojas" },
    { title: "Timings", icon: <FaClock />, path: "/admin/timings" },
    { title: "Festivals", icon: <FaCalendarAlt />, path: "/admin/festivals" },
    { title: "Idols", icon: <FaOm />, path: "/admin/idols" },
    { title: "Gallery", icon: <FaImages />, path: "/admin/gallery" },
    { title: "Live Darshan", icon: <FaVideo />, path: "/admin/live-darshan" },
    { title: "Spiritual Links", icon: <FaLink />, path: "/admin/links" },
    { title: "Contact", icon: <FaPhoneAlt />, path: "/admin/contact" },
  ];

  /* ================= ADMIN MENU ================= */

  const adminItems = [
    { title: "Pooja Bookings", icon: <FaPray />, path: "/admin/pooja-bookings" },
    { title: "Nakshatra Homam", icon: <FaStar />, path: "/admin/homam-bookings" },
    { title: "Users", icon: <FaUsers />, path: "/admin/users" },
    { title: "Donations", icon: <FaDonate />, path: "/admin/donations" },
    { title: "My Account", icon: <FaUserCircle />, path: "/admin/account" },
  ];

  return (
    <>
      {/* MOBILE TOGGLE */}
      <button
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* OVERLAY */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside className={`sidebar ${isOpen ? "active" : ""}`}>

        {/* LOGO */}
        <div className="sidebar-logo">
          <img src="/images/sailogo.png" alt="Sri Gnana Sai Baba Mandir Logo" className="sidebar-logo-image" />

          <div>
            <h2>SRI GNANA SAIBABA MANDIR</h2>
            <p>Admin Panel</p>
          </div>
        </div>

        {/* MAIN MENU */}
        <ul className="sidebar-menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={`sidebar-link ${
                  location.pathname === item.path ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-text">{item.title}</span>
              </Link>
            </li>
          ))}
        </ul>
        <ul className="sidebar-menu">
          {adminItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={`sidebar-link ${
                  location.pathname === item.path ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-text">{item.title}</span>
              </Link>
            </li>
          ))}
        </ul>

        {/* AUTH BUTTON */}
        <div className="sidebar-auth">

          {isLoggedIn ? (
            <button className="logout-btn" onClick={handleLogout}>
              <FaSignOutAlt /> Logout
            </button>
          ) : (
            <Link to="/admin/login" className="login-btn">
              <FaSignInAlt /> Login
            </Link>
          )}

        </div>

        {/* FOOTER */}
        <div className="sidebar-footer">
          <p>🙏 Om Sai Ram</p>
          <span>Sri Gnana Sai Baba Mandir</span>
        </div>

      </aside>
    </>
  );
};

export default Sidebar;
